exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-edit-material-modal_content-container{max-width:250px}", ""]);

// exports
